import { FC } from "react"
import { SafetiesSuccess } from "../../../module/safeties/containers/success"

export const SafetiesSuccessPage: FC = () => <SafetiesSuccess />
